import { useContext } from 'react';

import { SessionDataContext } from './SessionDataContext.ts';

export const useSessionData = () => useContext(SessionDataContext);
